import { render, staticRenderFns } from "./refundRecords.vue?vue&type=template&id=24737cb5&scoped=true&"
import script from "./refundRecords.vue?vue&type=script&lang=js&"
export * from "./refundRecords.vue?vue&type=script&lang=js&"
import style0 from "./refundRecords.vue?vue&type=style&index=0&id=24737cb5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24737cb5",
  null
  
)

export default component.exports